import { GamingPlatform, KeyRegion, KeyType } from 'root/src/shared/rewards/constants';
export const MAX_RESTRICTIONS_LENGTH = 80;
export const MAX_NAME_LENGTH = 55;
export const MAX_CTA_LENGTH = 25;
export const keyRewardSchema = {
    keyTypeEnum: Object.values(KeyType),
    platformEnum: Object.values(GamingPlatform),
    regionEnum: Object.values(KeyRegion),
};
